<template>
  <div class="col px-0 d-flex content-detail">
    <homecare-list ref="homecareList" class="col-3 d-flex flex-column" />
    <job-card class="col-6 d-flex flex-column" :job="job" v-if="job" />
    <job-detail class="col-3 d-flex flex-column" :job="job" v-if="job" />
  </div>
</template>

<script>
import axios from "axios";
import HomecareList from "./HomecareList";
import JobCard from "./JobCard";
import JobDetail from "./JobDetail";
import { getCookie, Auth } from "@/lib/cookie";

export default {
  components: {
    HomecareList,
    JobCard,
    JobDetail
  },
  data() {
    return {
      job: null
    };
  },
  computed: {
    jobId() {
      return this.$route.params.jobId;
    }
  },
  created() {
    if (this.jobId && this.jobId !== "all") {
      this.loadJob().then();
    }
  },
  watch: {
    $route(to) {
      if (to.params.jobId) {
        this.loadJob().then();
      }
    }
  },
  methods: {
    loadJob() {
      return axios
        .get(`${process.env.HOST}/admin/homecares/${this.jobId}`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          },
          params: {
            home_id: this.$route.query.home_id,
            project_id: this.$route.params.projectId
          }
        })
        .then(result => {
          this.job = result.data;
          this.setReadJob(this.jobId).then();
          return result.data;
        })
        .catch(() => {
          this.job = null;
          this.setReadJob(this.jobId).then();
        });
    },
    setReadJob(jobId) {
      this.$refs.homecareList.setJobStateReadBy(jobId);
      return axios.post(
        `${process.env.HOST}/admin/homecares/${jobId}/read`,
        {},
        {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          }
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/admin/view/homecare/Homecare.vue